import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DownloadIcon from '@8x8/oxygen-icon/novo/DownloadIcon'

import { downloadTranscriptAsText } from '~/actions/recents'
import { translate } from '~/core/translate'
import TranscriptPhrase from './phrase'
import {
  TranscriptContainer,
  TranscriptPhrasesList,
  TranscriptItem
} from './styled'
import { getSessionJids, getSessionTranscript } from '~/selectors/session-details'
import { getDialogProps, getViewedSessionId } from '~/selectors/ui'
import Button from '~/components/common/button'
import styled from 'styled-components'
import { BodyBold01 } from '~/components/common/typography'
import Modal from '~/components/common/modal'

const DownloadButton = styled(Button)`
  align-items: center;
  background: transparent;
  color: ${({ theme }) => theme._neo.action01};
  display: flex;
  height: auto;
  padding: 0;

  &:hover {
    background: inherit;
  }

  svg {
    fill: ${({ theme }) => theme._neo.action01};
  }

  ${BodyBold01} {
    margin-left: 8px;
  }
`

const TranscriptDialog = () => {
  const dispatch = useDispatch()
  const id = useSelector(getDialogProps).id ?? useSelector(getViewedSessionId)
  const jids = useSelector(getSessionJids(id))
  const phrases = useSelector(getSessionTranscript(id))

  const onDownloadClick = useCallback(() => {
    dispatch(downloadTranscriptAsText(id))
  }, [dispatch])

  const footerChildren = useMemo(() => (
    <DownloadButton
      onClick={() => onDownloadClick()}
    >
      <DownloadIcon />
      <BodyBold01>{translate('download')}</BodyBold01>
    </DownloadButton>
  ), [onDownloadClick])

  return (
    <Modal
      footerChildren={footerChildren}
      title={translate('meeting_transcript')}
    >
      <TranscriptContainer>
        <TranscriptPhrasesList>
          {phrases.map(entry => {
            const isOwnMessage = jids.includes(entry.jid)
            return (
              <TranscriptItem key={entry.messageId}>
                <TranscriptPhrase
                  authorId={entry.jid}
                  avatarUrl={entry.avatarUrl}
                  content={entry.text}
                  isOwnMessage={isOwnMessage}
                  name={entry.participantName}
                  timestamp={entry.timestamp}
                />
              </TranscriptItem>
            )
          })}
        </TranscriptPhrasesList>
      </TranscriptContainer>
    </Modal>
  )
}

export default TranscriptDialog
